import shoe1 from "../images/shoe/shoe (1).jpg";
import shoe2 from "../images/shoe/shoe (2).jpg";
import shoe3 from "../images/shoe/shoe (3).jpg";
import shoe4 from "../images/shoe/shoe (4).jpg";
import shoe5 from "../images/shoe/shoe (5).jpg";
import shoe6 from "../images/shoe/shoe (6).jpg";
import shoe7 from "../images/shoe/shoe (7).jpg";
import shoe8 from "../images/shoe/shoe (8).jpg";
import shoe9 from "../images/shoe/shoe (9).jpg";
import shoe10 from "../images/shoe/shoe (10).jpg";
import shoe11 from "../images/shoe/shoe (11).jpg";
import shoe12 from "../images/shoe/shoe (12).jpg";
import shoe13 from "../images/shoe/shoe (13).jpg";
import shoe14 from "../images/shoe/shoe (14).jpg";
import shoe15 from "../images/shoe/shoe (15).jpg";
import shoe16 from "../images/shoe/shoe (16).jpg";
import shoe17 from "../images/shoe/shoe (17).jpg";
import shoe18 from "../images/shoe/shoe (18).jpg";
import shoe19 from "../images/shoe/shoe (19).jpg";
import shoe20 from "../images/shoe/shoe (20).jpg";

export default [
  {
    id: 1,
    title: " کفش مردانه مدل راننیگ پلاس ",
    discount: "12%",
    image: shoe1,
    price: 399.0,
  },
  {
    id: 2,
    title: " کفش مردانه مدل تنتاک ویژه ",
    discount: "25%",
    image: shoe2,
    price: 410.0,
  },
  {
    id: 3,
    title: " کفش مردانه مدل اسیکس ",
    discount: "45%",
    image: shoe3,
    price: 549.0,
  },
  {
    id: 4,
    title: " کفش مردانه مدل A ",
    discount: "22%",
    image: shoe4,
    price: 619.0,
  },
  {
    id: 5,
    title: " کفش زنانه مدل H ",
    discount: "33%",
    image: shoe5,
    price: 300.0,
  },
  {
    id: 6,
    title: " کفش بچه گانه مدل M ",
    discount: "54%",
    image: shoe6,
    price: 199.0,
  },
  {
    id: 7,
    title: " کفش ورزشی  ",
    discount: "45%",
    image: shoe7,
    price: 149.0,
  },
  {
    id: 8,
    title: " کفش کوهنوردی ",
    discount: "25%",
    image: shoe8,
    price: 379.0,
  },
  {
    id: 9,
    title: " کفش مدل ورزشی M&M ",
    discount: "25%",
    image: shoe9,
    price: 770.0,
  },
  {
    id: 10,
    title: " کفش پیاده روی ",
    discount: "20%",
    image: shoe10,
    price: 777.0,
  },
  {
    id: 11,
    title: "کفش شیک ورزشی",
    discount: "2%",
    image: shoe11,
    price: 110.0,
  },
  {
    id: 12,
    title: " کفش مدل مجلسی ",
    discount: "4%",
    image: shoe12,
    price: 388.0,
  },
  {
    id: 13,
    title: " کفش ورزشی مدل تابستانه ",
    discount: "25%",
    image: shoe13,
    price: 880.0,
  },
  {
    id: 14,
    title: " کفش زنانه B&B  ",
    discount: "9%",
    image: shoe14,
    price: 220.0,
  },
  {
    id: 15,
    title: " کفش مردانه مدل R&R ",
    discount: "14%",
    image: shoe15,
    price: 111.0,
  },
  {
    id: 16,
    title: " کفش مردانه مدل H&H ",
    discount: "11%",
    image: shoe16,
    price: 208.0,
  },
  {
    id: 17,
    title: " کفش مردانه مدل D&D ",
    discount: "15%",
    image: shoe17,
    price: 615.0,
  },
  {
    id: 18,
    title: " کفش مدل WWW ",
    discount: "10%",
    image: shoe18,
    price: 770.0,
  },
  {
    id: 19,
    title: "  کفش پیاده روی ",
    discount: "25%",
    image: shoe19,
    price: 777.0,
  },
  {
    id: 20,
    title: "  کفش شیک مدل پاییز ",
    discount: "5%",
    image: shoe20,
    price: 110.0,
  },
];
